export default __webpack_public_path__ + "static/media/two.85deaaaa.png";